let html = `<div class="modal">
    <div class="modal__content">
        <div class="modal__head">
            <div class="modal__title">{title}</div>
        </div>
        <div class="modal__body">
            
        </div>
    </div>
</div>`

export default html